<template>
  <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-fill-gear display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            GESTION DE RENOVACION
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE TRABAJADORES
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <button :class="{ 'btn btn-success mt-2 ms-2': individual }" class="btn btn-secondary mt-2 ms-2" @click="Indi"
        title="Opción para renovación de un solo trabajador (Marcar un valor de la opción ACCION)">
        <i class="bi bi-files"></i>
      </button>

      <button :class="{ 'btn btn-success mt-2 ms-2': masivo }" class="btn btn-secondary mt-2 ms-2" @click="Masi"
        title="Opción para renovación de uno o más trabajadores (Marcar más de un valor de la opción ACCION)">
        <i class="bi bi-archive"></i>
      </button>

      <button @click="CargaMasiva" class="btn btn-primary mt-2 ms-2" v-if="masivo">
        <i class="bi bi-arrow-up-square"></i>
      </button>

      <button @click="CrearPdfMasivo" class="btn btn-danger mt-2 ms-2" v-if="masivo">
        <i class="bi bi-file-earmark-pdf"></i>
      </button>

      <button class="btn btn-warning mt-2 ms-2" @click="MarcarSSCC" title="MARCAR SSCC">
        <i class="bi bi-building-fill-check"></i>
      </button>

      <button @click="BusquedaFiltros" class="btn btn-success mt-2 ms-2">
        <i class="bi bi-search"></i>
      </button>

      <button class="btn btn-light mt-2 ms-2">
        <svg @click="off = !off" xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" :class="{
          'bi-toggle-off': off,
          'bi-toggle-on': !off,
          'toggle-transition': true,
        }" viewBox="0 0 16 16">
          <path :class="{ 'toggle-transition text-secondary': true }" v-if="off"
            d="M11 4a4 4 0 0 1 0 8H8a4.992 4.992 0 0 0 2-4 4.992 4.992 0 0 0-2-4h3zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
          <path :class="{ 'toggle-transition text-primary': true }" v-else
            d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
        </svg>
      </button>

      <button
        @click="idEmpresaParametro = '', perAno = '0', perMes = '0', GestionRenovacion(), primeraTabla = true"
        class="btn btn-info mt-2 ms-2 text-white">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <!-- <div>
        <button class="btn btn-danger mx-2" @click="Indi">individual</button>
      <button class="btn btn-success" @click="Masi">masivo</button>
      </div> -->

    <div class="mt-2 pb-2">
      <div class=" border border-1 rounded-3 p-3 mb-2">
        <div class="row gy-2 gx-2">

        
         
          <div class="col-lg-3 col-md-4 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-credit-card-2-front text-primary"></i> DNI
            </label>
            <b-input :disabled="Ciudad.length > 0 || Apellidos.length > 0 || SubSubCentro.length > 0 || Cliente.length > 0" class="p-2 my-0"
              id="searchInput1" v-model="Dni" placeholder="BUSQ. POR DNI" @input="Dni = Dni.replace(/\s+/g, '')"></b-input>              
          </div>

         <div class="col-lg-3 col-md-4 col-sm-12">
          <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-person-lines-fill text-primary"></i> APELLIDOS
            </label>
            <b-input class="p-2 my-0" v-model.trim="Apellidos" :disabled="Dni.length > 0 || SubSubCentro.length > 0 || Ciudad.length > 0 || Cliente.length > 0" placeholder="BUSQ. POR APELLIDOS"
              @input="Apellidos = Apellidos.replace(/^\s+/, '')"
              @keydown.space="Apellidos.length === 0 && $event.preventDefault()"></b-input>
          </div>

                 <!-- Cliente -->
          <div class="col-lg-3 col-md-4 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-buildings text-primary"></i> CANAL
            </label>
            <b-input :disabled="Dni.length > 0 || Apellidos.length > 0 || Ciudad.length > 0 || Cliente.length > 0" class="p-2 my-0"
              id="searchInput3" v-model="SubSubCentro" placeholder="BUSQ. POR CANAL" @input="SubSubCentro = SubSubCentro.replace(/^\s+/, '')"></b-input>
          </div>

          <div class="col-lg-3 col-md-4 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-person-badge text-primary"></i> CLIENTE
            </label>
            <b-input :disabled="Dni.length > 0 || Apellidos.length > 0 || SubSubCentro.length > 0 || Ciudad.length > 0" class="p-2 my-0"
              v-model="Cliente" placeholder="BUSQ. POR CLIENTE" @input="Cliente = Cliente.replace(/^\s+/, '')"></b-input>
          </div>

          <!-- Ciudad -->
          <div class="col-lg-3 col-md-4 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-geo-alt text-primary"></i> CIUDAD
            </label>
            <b-input :disabled="Dni.length > 0 || Apellidos.length > 0 || SubSubCentro.length > 0 || Cliente.length > 0" class="p-2 my-0"
              id="searchInput4" v-model="Ciudad" placeholder="BUSQ. POR CIUDAD" @input="Ciudad = Ciudad.replace(/^\s+/, '')"></b-input>
          </div>


            <!-- <div class="col-lg-3 col-md-4 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-calendar-event text-success"></i> AÑO
            </label>
            <select v-model="perAno" class="form-select p-2 my-0 w-100" style="font-size: 0.8rem;">
              <option disabled selected value="0">-- AÑO --</option>
              <option v-for="año in años" :key="año.value" :value="año.value">
                {{ año.label }}
              </option>
            </select>
          </div>

          <div class="col-lg-3 col-md-4 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-calendar-month text-warning"></i> MES
            </label>
            <select v-model="perMes" class="form-select p-2 my-0 w-100" style="font-size: 0.8rem;">
              <option disabled selected value="0">-- MES --</option>
              <option v-for="mes in meses" :key="mes.value" :value="mes.value">
                {{ mes.label }}
              </option>
            </select>
          </div> -->

          <!-- Estado -->
          <!-- <div class="col-lg-3 col-md-4 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-flag-fill text-secondary"></i> ESTADO
            </label>
              <select v-model="estadoParams" class="form-select p-2 my-0 w-100" style="font-size: 0.8rem;">
              <option disabled selected value="">-- ESTADO --</option>
              <option v-for="estados in Estado" :key="estados.id" :value="estados.parCorrelativo">
                {{ estados.parDescripcion }}
              </option>
            </select>
          
          </div> -->

             <div class="col-lg-1 col-md-4 col-sm-12 d-flex align-items-end">        
          
            <button @click="BuscarCampaña('002')" class="btn btn-success btn-sm w-100" title="Buscar Campaña">
              <i class="bi bi-rocket-takeoff-fill"></i>
            </button>
     
          </div>

        </div>
        <!-- <div class="d-flex justify-content-end mt-2">
            
            <select @change="estadoParams = $event.target.value"
            class="form-select p-2 w-auto ms-2"
            id="exampleFormControlSelect1"
          >
            <option disabled selected>-- SELECCIONAR ESTADO --</option>
            <option
              v-for="estados in Estado"
              :key="estados.id"
              :value="estados.parCorrelativo"
            >
              {{ estados.parDescripcion }}
            </option>
          </select>
        </div>  -->

          <!-- <div v-if="busquedaValidacion" class="col-md-3">
          <input
            class="form-control p-2 w-100"
            type="text"
            aria-label=".form-control-lg example"
            v-model="busqueda"
            placeholder="BUSCAR POR CLIENTE"
            @input="Filtro"
          />
        </div> -->
        </div>
      </div>
    
    <!-- <div class="row"> -->
    <!-- <div class="col col-3 ms-3">
        <button class="btn btn-primary w-100 mt-3" @click="CambiarEstado">
          MARCAR TODOS
        </button>
      </div> -->

    <!-- <div class="col col-3 ms-3">
       
      </div> -->
    <!-- </div> -->

    <!-- este codigo no se para que servia -->
    <!-- <div class="border border-1 rounded-3 p-3 mb-2 ">
       <div class="row ">
        <div class="col-md-12 reducirTamaño label-resaltado">
          <label>LEYENDA</label>
        </div>

        <div class="col-md-3 label-resaltado">
          <i class="bi bi-files"> Renovación individual del trabajador</i> <br />
          <i class="bi bi-archive"> Renovación de uno o más trabajadores</i>
          <br />
          <i class="bi bi-arrow-up-square"> Carga Masiva</i> <br />
          <i class="bi bi-file-earmark-pdf"> Crear PDF Masivo</i> <br />
        </div>

        <div class="col-md-3 label-resaltado">
          <i class="bi bi-building-fill-check"> Marcar Centro de Costo</i> <br />
          <i class="bi bi-search"> Guardar filtro seleccionado</i> <br />
          <i class="bi bi-toggle-on"> Encendido o Apagado de columnas</i> <br />
          <i class="bi bi-eye"> Visualizador de detalle del trabajador</i> <br />
        </div>

        <div class="col-md-3 label-resaltado">
          <i class="bi bi-file-earmark">
            Generar contrato de renovación sin firmas</i>
          <br />
          <i class="bi bi-hand-thumbs-up-fill"></i> Aprobar el contrato de
          renovación sin firmas <br />
          <i class="bi bi-cloud-upload"></i> Cargar para firma de la empresa
          <br />
          <i class="bi bi-file-pdf"></i> Descargar el contrato de renovación con
          ambas firmas<br />
        </div>

        <div class="col-md-3 label-resaltado">
          <i class="bi bi-check-circle-fill"></i> Aceptar el proceso de renovación
          <br />
          <i class="bi bi-award-fill"></i> Generar de firma digital <br />
          <i class="bi bi-file-medical"></i> Contrato de renovación con firma
          digital<br />
          <i class="bi bi-x-octagon"> Cambiar a estado de cesado al trabajador</i>
        </div>
      </div> 

      <div class="modal" v-if="showModal">
        <div class="modal-content" @mouseleave="closeModal">
          <div class="row">
            <div class="col-7 gx-0">
              <div class="px-3 mt-2 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual"
                :key="usu.id">
                <p>
                  <strong class="label-column"> Periodo:</strong>
                  <label>{{ usu.periodo }}</label>
                </p>
                <p>
                  <strong class="label-column">Ruc:</strong><label> {{ usu.ruc }}</label>
                </p>
                <p>
                  <strong class="label-column">Razon Social:</strong><label>{{ usu.nomLargoEmp }}</label>
                </p>
                <p>
                  <strong class="label-column">SCC:</strong>
                  <label>{{ usu.subCentroCostos }}</label>
                </p>

                <p>
                  <strong class="label-column">SSCC:</strong>
                  <label>{{ usu.subSubCentroCostos }}</label>
                </p>

                <p>
                  <strong class="label-column"> Dirección: </strong>
                  <label>{{ usu.direccion }}</label>
                </p>
              </div>
            </div>

            <div class="col-5 gx-0">
              <div class="mt-2 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual" :key="usu.id">
                <p>
                  <strong class="label-column"> Estado:</strong>
                  <label>{{ usu.renCodEstado }}</label>
                </p>

                <p>
                  <strong class="label-column">N° Documento:</strong>
                  {{ usu.nroDocumento }}
                </p>
                <p>
                  <strong class="label-column">Apellidos y nombres:</strong>
                  {{ usu.nomTrabajador }}
                </p>

                <p>
                  <strong class="label-column"> Ciudad: </strong>
                  {{ usu.departamento }}
                </p>
              </div>
            </div>
          </div>

          <div class="mx-5 mt-2">
            <div class="row gy-3 mx-5">
              <div class="col-6">
                <h5><strong>Valores actuales</strong></h5>
              </div>
              <div class="col-6">
                <h5><strong> Valores posteriores a la renovación</strong></h5>
              </div>

              <div class="col-5 gx-0">
                <div class="mt-2 px-3 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual"
                  :key="usu.id">
                  <p>
                    <strong class="label-column">Sueldo Actual: </strong>
                    <label> {{ usu.renSueldoActual }}</label>
                  </p>

                  <p>
                    <strong class="label-column">Fecha ini. actual:</strong>
                    <input class="border border-2 ms-2 rounded text-center" type="date"
                      :value="usu.fecIniConActual.slice(0, 10)" name="" id="" />
                  </p>
                  <p>
                    <strong class="label-column">Fecha fin actual:</strong>

                    <input class="border border-2 ms-2 rounded text-center" type="date" name=""
                      :value="usu.fecFinConActual.slice(0, 10)" id="" />
                  </p>
                  <p>
                    <strong class="label-column">Puesto:</strong>
                    {{ usu.nomPuesto }}
                  </p>
                </div>
              </div>

              <div class="col-2 py-0 d-flex justify-content-center">
                <div class="bg-dark" style="width: 3px; height: 100%; margin: 0; padding: 0"></div>
              </div>

              <div class="col-5 gx-0">
                <div class="mt-2 px-3 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual"
                  :key="usu.id">
                  <p>
                    <strong class="label-column">Sueldo: </strong>
                    {{ usu.renSueldo }}
                  </p>
                  <p>
                    <strong class="label-column">Fecha ini. contrato:</strong>
                    <input class="border border-2 rounded text-center" type="date" name=""
                      :value="usu.fechaIniContrato.slice(0, 10)" id="" />
                  </p>
                  <p>
                    <strong class="label-column">Fecha fin contrato:</strong>
                    <input class="border border-2 rounded text-center" type="date"
                      :value="usu.fechaFinContrato.slice(0, 10)" name="" id="" />
                  </p>

                  <p>
                    <strong class="label-column">PuestoNuevo:</strong>
                    {{ usu.nomPuestoNuevo }}
                  </p>
                </div>
              </div>

              <div class="col-6" v-for="usu in usuarioIndividual" :key="usu.id">
                <p>
                  <strong>Días antes de la renovación: </strong>
                  {{ usu.diasRen }}
                </p>
              </div>

              <div class="col-6" v-for="usu in usuarioIndividual" :key="usu.id">
                <p>
                  <strong>Record de Trabajador: </strong>
                  {{ usu.diasTrabajador }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-5 gx-0">
            <div class="mt-2 d-flex flex-column align-items-start">
              <button @click="cerrar" class="btn btn-danger">cerrar</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="border border-1 rounded-3 p-3 ">

      <button @click="AccionRenMasivo" class="btn btn-secondary"><i class="bi bi-people-fill"></i></button>

     
      <button   @click="BuscarAccionRenMasivo(MarcarDesmarcar())" class="btn btn-secondary ms-4"><i :class="ultimoEstadoMarcado == 1 ? 'bi bi-check-square' : 'bi bi-check-square-fill'"></i></button>

      

      <div class="d-flex justify-content-end mt-3 mx-2">
        <div
          class="d-flex align-items-center px-3 py-2 bg-primary bg-opacity-10 border border-primary rounded-3 shadow-sm">
          <i class="bi bi-people-fill text-primary fs-5 me-2"></i>
          <span class="fw-bold text-primary">
            Total de trabajadores: {{ ItemsGestion.length }}
          </span>
        </div>
      </div>


      <div v-if="individual" class="table-responsive mx-2 mt-2">
        <!-- tbody-tr-class="text-nowrap text-center" -->
        <!-- thead-tr-class="text-nowrap text-white" -->
        <table v-if="primeraTabla" class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col">
                <div @click="MarcarTodos()"
                  :class="seleccionadosMasivo.length > 0 ? 'bg-dark border-white' : 'bg-white border-white'"
                  style="cursor: pointer; width: 12px; height: 12px; border: 1px solid; display: inline-block; border-radius: 2px; transition: 0.2s;">
                </div>
              </th>
              <th scope="col">OPCIONES</th>
              <!--<th v-if="off" scope="col">PERIODO</th>-->
              <th scope="col">ESTADO</th>
              <th v-if="off" scope="col">MOTIVO</th>
              <th v-if="off" scope="col">CIUDAD</th>
              <!--<th scope="col">DOC. IDENTIDAD</th>-->
              <th scope="col">CLIENTE</th>
              <th scope="col">TRABAJADOR</th>
              <!--<th v-if="off" scope="col">CC</th>-->
              <!--<th v-if="off" scope="col">SCC</th>-->
              <th scope="col">ACTUAL CONTRATO</th>
              <!-- <th v-if="off" scope="col">SUELDO ACTUAL</th> -->
              <!-- <th v-if="off" scope="col">NUEVO SUELDO</th> -->
              <!--<th v-if="off" scope="col">INICIO CONTRATO</th>-->
              <!--<th v-if="off" scope="col">FIN CONTRATO</th>-->
              <th scope="col">NUEVO CONTRATO</th>
              <!--<th scope="col">FIN NUEVO CONTRATO</th>-->
              <!-- <th v-if="off" scope="col">VCTO.</th> -->
              <!-- <th v-if="off" scope="col">DIAS TRAB.</th> -->
              <th scope="col">RECORD TRAB.</th>
              <th scope="col">OPCION DE RECHAZO</th>
            </tr>
          </thead>

          <tbody class="align-middle">
            <tr :class="{ 'disabled-row': itema.diasTrabajador > 1260 , 'bg-check' : itema.accionRen }" class="text-center align-middle reducirTamaño"
              v-for="itema in itemsPaginados" :key="itema.id">
              <!--<td class="align-middle text-center">-->
              <!--<strong>{{ itema.idRenovacion }}</strong>-->
              <!--</td>-->

              <td scope="row" class="text-center tabla-estiloCompreso">
                <div class="d-flex align-items-center justify-content-center">
                  <input class="checki" @change="actualizarEstado(itema)" type="checkbox" :value="itema.idRenovacion"
                    v-model="itema.accionRen" />
                </div>
              </td>

              <td scope="row" class="text-center tabla-estiloCompreso">
                <div class="d-flex">
                  <button @click="DescargarPdf(itema)" class="btn btn-outline-primary boton-estiloCuadrado">
                    <i class="bi bi-file-earmark"></i>
                  </button>

                  <button class="btn boton-estiloCuadrado" :class="{
                    'btn btn-success text-light': itema.estadoPdf,
                    'btn btn-light text-success': !itema.estadoPdf,
                  }" @click="cambiarEstadoPdf(itema.idRenovacion)">
                    <i class="bi bi-hand-thumbs-up-fill"></i>
                  </button>

                  <label for="file-upload" class="btn btn-outline-primary boton-estiloCuadrado" @click="
                    mandarPdfServicios(
                      itema.idRenovacion,
                      itema.idTrabajador,
                      itema.numeroDoc,
                      itema.nomTrabajador
                    )
                    ">
                    <i class="bi bi-cloud-upload"></i>
                  </label>
                  <input id="file-upload" class=" " type="file" accept=".pdf" @change="handleFileUpload" ref="fileInput"
                    :key="fileInputKey" />

                  <button :disabled="!itema.estadoAdjunto" :class="{
                    'btn-outline-danger': !itema.estadoAdjunto,
                    'btn btn-danger text-white': itema.estadoAdjunto,
                  }" class="btn boton-estiloCuadrado">
                    <a :class="{
                      'text-danger': !itema.estadoAdjunto,
                      'text-white': itema.estadoAdjunto,
                    }" :href="url + itema.renAdjunto.split('Legajo\\')[1]" target="_blank">
                      <!-- itema.numeroDoc +
                      '/' +
                      itema.idRenovacion+ '_' +itema.numeroDoc +'_' + itema.nomTrabajador.replace(/ /g, '_') + '_'+ fechaDeahora + 
                      '.pdf' -->
                      <i class="bi bi-file-pdf"></i></a>
                  </button>

                  <button :disabled="(from.idRenovacion == itema.idRenovacion ||
                    itema.accionRen == true) &&
                    itema.estadoAdjunto
                    ? false
                    : true
                    " @click="Registro(itema)" class="btn btn-outline-success boton-estiloCuadrado">
                    <i class="bi bi-check-circle-fill"></i>
                  </button>
                </div>

                <button v-if="!off" class="btn btn-outline-info boton-estiloCuadrado mt-2"
                  @mouseover="openModal(itema.idRenovacion)">
                  <i class="bi bi-eye"></i>
                </button>

                <!-- <button @click="Firma(itema)" class="btn btn-outline-warning boton-estiloCuadrado mt-2">
                                    <i class="bi bi-award-fill"></i>
                                </button>

                                <button class="btn btn-warning boton-estiloCuadrado mt-2">
                                    <a :href="url + itema.idTrabajador + '.pdf'" target="_blank">
                                    <i class="bi bi-file-medical"></i>
                                    </a>
                                </button>
                            -->
                <button @click="cambiarEstadoRen(itema)"
                  class="btn btn-warning text-black boton-estiloCuadrado mx-2 mt-2">
                  <i class="bi bi-person-fill-x"></i>
                </button>
                
              </td>

              <td class="text-start fw-bold">
                <label> {{ itema.periodo }} </label><br />
                <label for="" :class="{
                  'text-primary': itema.renCodEstado == 'EN PROCESO',
                  'text-warning': itema.renCodEstado == 'SOLICITADO',
                  'text-danger': itema.renCodEstado == 'NO RENOVADO',
                }">{{ itema.renCodEstado }}</label>
              </td>

              <td v-if="off" class="text-center">
                <label v-if="itema.nomMotivo.length > 0" for="" class="px-2">
                  {{ itema.nomMotivo }}</label>
                <label class="text-center" v-else> -</label>
              </td>

              <td v-if="off" class="text-center">
                {{ itema.departamento }}
              </td>

              <!--<td class="align-middle text-center">{{ itema.nroDocumento }}</td>-->
              <td class="text-start">
                <label>{{ itema.nomEmpresa }} </label><br />
                <label>{{ itema.subCentroCostos }} </label><br />
                <label>{{ itema.subSubCentroCostos }} </label>
              </td>

              <td class="text-start fw-bold">
                <label class="">{{ itema.nroDocumento }}</label> <br />
                <label class="">{{ itema.nomTrabajador }}</label>
              </td>

              <!--<td v-if="off" class="align-middle text-center"> {{ itema.nomEmpresa }} </td>-->
              <!--<td v-if="off" class="align-middle text-center"> {{ itema.subCentroCostos }} </td>-->

              <!--<td class="align-middle text-center">
                            <select
                                @change="SubSubCentroCostosManda($event)"
                                v-if="itema.accionRen"
                                class="form-control text-center soli"
                                id="exampleFormControlSelect1"
                                disabled
                            >
                                <option disabled selected>
                                {{ itema.subSubCentroCostos }}
                                </option>
                                <option
                                v-for="subSubCentro in SubSubCentroCosto"
                                :key="subSubCentro.id"
                                :value="subSubCentro.cenSubSubCodigo"
                                >
                                {{ subSubCentro.cenNombre }}
                                </option>
                            </select>

                            <label for="" class="" v-else>{{
                                itema.subSubCentroCostos
                            }}</label>
                            </td> -->

              <td class="text-center">
                <!--<select @change="Puesto($event)" v-if="itema.accionRen" class="form-control text-center" id="exampleFormControlSelect1" disabled>-->
                <!--<option disabled selected>{{ itema.nomPuestoNuevo }}</option>-->
                <!--<option v-for="puestos in puesto" :key="puestos.id" :value="puestos.idPuesto">{{ puestos.ptoNombre }}</option>-->
                <!--</select>-->

                <!--<label for="" class="py-2" v-else>{{itema.nomPuestoNuevo}}</label>-->
                <label>{{ itema.nomPuesto }}</label><br />
                <label>
                  {{
                    new Date(itema.fecIniConActual).toLocaleDateString("es-ES")
                  }}
                </label>
                -
                <label>
                  {{
                    new Date(itema.fecFinConActual).toLocaleDateString("es-ES")
                  }} </label><br />
                <label>SUELDO ACTUAL: {{ itema.renSueldoActual }}</label>
              </td>

              <!-- <td v-if="off" class="text-center">{{ itema.renSueldoActual }}</td> -->

              <!-- <td v-if="off" class="text-center">
                        <div class="form-group text-center">
                            <p v-if=" sueldoFinal >itema.renSueldoActual * 0.2 + itema.renSueldoActual && from.idRenovacion == itema.idRenovacion">
                            No puedes exceder el 20% del sueldo Actual
                            </p>

                            <div class="form-group text-center">
                            <input
                                v-if="itema.accionRen"
                                type="text"
                                class="form-control text-center"
                                id="exampleInputEmail1"
                                @change="mostrar($event)"
                                v-model="itema.renSueldo"
                                disabled
                                aria-describedby="emailHelp"
                            />

                            <label for="" class="text-center" v-else>{{itema.renSueldo}}</label>
                            </div>
                        </div>
                        </td> -->

              <!--<td class="text-center text-success fw-bold"><label>{{itema.renSueldo}}</label></td>-->

              <!--<td v-if="off" class="text-center">-->
              <!--<label v-if="itema.fecIniConActual.slice(0, 10) == '1900-01-01'" disabled class="text-center text-black"> - </label>-->
              <!--<input v-else disabled class="text-center" type="date" :value="itema.fecIniConActual.slice(0, 10)"/>-->
              <!--</td>-->

              <!--<td v-if="off" class="text-center">-->
              <!--<input disabled class="text-center" type="date" :value="itema.fecFinConActual.slice(0, 10)"/>-->
              <!--</td>-->

              <!--<td v-if="off" class="text-center"> -->
              <!--                <input v-if="isdisabled2 == true" class="text-center" disabled @change="FechaIni($event)" type="date" :value="itema.fecIniConActual.slice(0, 10)"/>-->
              <!--<input v-else class="text-center" disabled @change="FechaIni($event)" type="date" :value="itema.fechaIniContrato.slice(0, 10)"/>-->
              <!--</td>-->

              <!--<td class="text-center">-->
              <!--<input v-if="itema.accionRen" class="text-center" @change="FechaFin($event)" disabled type="date" :value="itema.fechaFinContrato.slice(0, 10)"/>-->
              <!--<input v-else disabled class="text-center" @change="FechaFin($event)" type="date" :value="itema.fechaFinContrato.slice(0, 10)"/>-->
              <!--</td>-->

              <td class="text-center text-success fw-bold">
                <label>{{ itema.nomPuestoNuevo }}</label><br />
                <label>
                  {{
                    new Date(itema.fechaIniContrato).toLocaleDateString("es-ES")
                  }}
                </label>
                -
                <label>
                  {{
                    new Date(itema.fechaFinContrato).toLocaleDateString("es-ES")
                  }} </label><br />
                <label>NUEVO SUELDO: {{ itema.renSueldo }}</label>
              </td>

              <!-- <td v-if="off" class="text-center">
                <div class="text-start fw-bold">
                  <label :class="{
                    'text-danger': itema.diasRen < 10,
                    'text-center': true,
                  }">En {{ itema.diasRen }} Días</label>
                </div>
              </td> -->

              <!-- <td v-if="off" class="text-center fw-bold">
                {{ itema.diasTrabajador }}
              </td> -->

              <td class="align-middle text-center">
                <div class="form-group w-auto d-flex align-items-center">
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoAño.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoAño.slice(0, 1) == 1">
                    {{ itema.formatoAño }} año
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoAño.slice(0, 1) != 1 &&
                    itema.formatoAño.slice(0, 1) != 0
                  ">
                    {{ itema.formatoAño }} años
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoMes.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoMes.slice(0, 1) == 1">
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    {{ itema.formatoMes }} meses
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoDias.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoDias.slice(0, 1) == 1">
                    {{ itema.formatoDias }} días
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    {{ itema.formatoDias }} días
                  </p>
                </div>
              </td>

              <td class="" >
                <div class="d-flex">
                  <select @change="Motivo($event)" class="form-control reducirTamaño">
                    <option disabled selected>-- SELECCIONAR MOTIVO --</option>
                    <option v-for="motivos in motivo" :key="motivos.id" :value="motivos.parDescripcion">
                      {{ motivos.parDescripcion }}
                    </option>
                  </select>

                  <button @click="Rechazo(itema.idRenovacion, itema)"
                    class="btn btn-outline-success boton-estiloCuadrado">
                    <i class="bi bi-floppy"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- REVISAR  SI ESTA TABLA FUNCIONA PARA ELIMINARLO -->
    
      </div>
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <!-- Ir al inicio -->
        <button class="btn btn-outline-primary btn-sm" @click="irInicio" :disabled="pag === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <!-- Retroceder -->
        <button class="btn btn-outline-primary btn-sm" @click="retroceso" :disabled="noRetroceder || pag === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <!-- Info de página -->
        <span class="pagination-info small px-2">
          Página {{ pag }} de {{ totalPages }}
        </span>

        <!-- Avanzar -->
        <button class="btn btn-outline-primary btn-sm" @click="aumentar"
          :disabled="noAvanzar || pag === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>

        <!-- Ir al final -->
        <button class="btn btn-outline-primary btn-sm" @click="irFinal"
          :disabled="pag === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>

      <div v-if="masivo" class="mt-2 mx-2 table-responsive">
        <table class="table mt-3 table-bordered">
          <thead>
            <tr class="text-nowrap text-white bg-solimano">
              <th scope="col">ACCION</th>
              <th scope="col">ESTADO</th>
              <th scope="col">MOTIVO</th>
              <th scope="col">DOC. IDENTIDAD</th>
              <th scope="col">NOMBRES</th>
              <th scope="col">CC</th>
              <th scope="col">SCC</th>
              <th scope="col">SUB SUB CENTRO</th>
              <th scope="col">PUESTO</th>
              <th scope="col">SUELDO ACTUAL</th>
              <th scope="col">SUELDO</th>
              <th scope="col">FEC.INI CONTRATO</th>
              <th scope="col">FEC.FIN CONTRATO</th>
              <th scope="col">FEC.INI NUEVO CONTRATO</th>
              <th scope="col">FEC.FIN NUEVO CONTRATO</th>
              <th scope="col">VCTO. DE CONTRATO</th>
              <th scope="col">DIAS TRABAJADOR</th>
              <th scope="col">RECORD TRABAJADORES</th>
              <th scope="col">OPCION DE RECHAZO</th>
            </tr>
          </thead>
          <tbody class="align-middle">
            <tr cl class="text-nowrap" v-for="itema in ItemsGestion" :key="itema.id">
              <th class="py-3" scope="row">
                <div class="px-4">
                  <input class="checki" type="checkbox" v-model="checkeId" :value="itema.idRenovacion" />
                </div>
              </th>

              <td class="py-3">
                <label for="" :class="{
                  'text-primary': itema.renCodEstado == 'EN PROCESO',
                  'text-warning oscuro': itema.renCodEstado == 'SOLICITADO',
                }">{{ itema.renCodEstado }}</label>
              </td>

              <td class="py-3">{{ itema.nroDocumento }}</td>
              <td class="text-left py-3">
                <label for="" class="px-2">{{ itema.nomTrabajador }}</label>
              </td>
              <td class="py-3">{{ itema.nomEmpresa }}</td>
              <td class="py-3">{{ itema.subCentroCostos }}</td>

              <td>
                <label for="" class="py-2">{{
                  itema.subSubCentroCostos
                }}</label>
              </td>

              <td class="">
                <label for="" class="py-2">{{ itema.nomPuestoNuevo }}</label>
              </td>

              <td class="py-3">{{ itema.renSueldoActual }}</td>
              <td>
                <div class="form-group">
                  <p v-if="
                    sueldoFinal >
                    itema.renSueldoActual * 0.2 + itema.renSueldoActual &&
                    from.idRenovacion == itema.idRenovacion
                  ">
                    No puedes exceder el 20% del sueldo Actual
                  </p>

                  <div class="form-group">
                    <label for="" class="text-center py-2">{{
                      itema.renSueldo
                    }}</label>
                  </div>
                </div>
              </td>

              <td>
                <label v-if="itema.fecIniConActual.slice(0, 10) == '1900-01-01'" disabled
                  class="text-center text-black py-2">
                  -----------
                </label>

                <input v-else disabled class="form-control text-center text-secondary" type="date"
                  :value="itema.fecIniConActual.slice(0, 10)" />
              </td>

              <td class="text-center">
                <input disabled class="form-control text-center text-secondary" type="date"
                  :value="itema.fecFinConActual.slice(0, 10)" />
              </td>

              <td>
                <input disabled class="form-control text-secondary" type="date"
                  :value="itema.fecIniConActual.slice(0, 10)" />
              </td>

              <td>
                <input disabled class="texte-center form-control text-secondary" @change="FechaFin($event)" type="date"
                  :value="itema.fechaFinContrato.slice(0, 10)" />
              </td>

              <td>
                <div class="tamaño d-flex">
                  <!-- <select
              disabled
              @change="Motivo($event)"
              class="form-control"
              id="exampleFormControlSelect1"
            >
              <option disabled selected>Seleccionar motivo</option>
              <option
                v-for="motivos in motivo"
                :key="motivos.id"
                :value="motivos.parDescripcion"
              >
                {{ motivos.parDescripcion }}
              </option>
            </select> -->

                  <label v-for="motivos in motivo" :key="motivos.id" for="">{{
                    motivos.parDescripcion
                  }}</label>
                </div>
              </td>

              <td class="py-3">
                <div class="mx-3">
                  <label for="" class="text-center">{{ itema.diasRen }} Días</label>
                </div>
              </td>

              <td class="py-3">{{ itema.diasTrabajador }}</td>

              <td class="py-3">
                <div class="form-group w-auto">
                  <label for="" class="d-flex text-center">
                    <p class="mx-1" v-if="itema.formatoAño.slice(0, 1) == 0"></p>
                    <p v-if="itema.formatoAño.slice(0, 1) == 1">
                      {{ itema.formatoAño }} año
                    </p>
                    <p v-if="
                      itema.formatoAño.slice(0, 1) != 1 &&
                      itema.formatoAño.slice(0, 1) != 0
                    ">
                      {{ itema.formatoAño }} años
                    </p>
                    <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 0"></p>
                    <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 1">
                      {{ itema.formatoMes }} mes
                    </p>
                    <p class="mx-2" v-if="
                      itema.formatoMes.slice(0, 1) != 1 &&
                      itema.formatoMes.slice(0, 1) != 0
                    ">
                      {{ itema.formatoMes }} meses
                    </p>
                    <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 0"></p>
                    <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 1">
                      {{ itema.formatoDias }} días
                    </p>
                    <p class="mx-2" v-if="
                      itema.formatoDias.slice(0, 1) != 1 &&
                      itema.formatoDias.slice(0, 1) != 0
                    ">
                      {{ itema.formatoDias }} días
                    </p>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "SolimanologGestionRenovacionIndividual",

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Legajo/",
      // url: "https://apitopas.gruposolimano.com.pe/Documentos/Renovacion/",
      // url:"file:///C:/Users/HP/Desktop/Pruebas_Documentos/",
      individual: true,
      masivo: false,
      checkeId: [],
      pdfMasivo: [],
      perPage: 10,
      currentPage: 1,
      pdfIndividual: [],
      texto: "",
      idRenovacion: "",
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      Cliente: "",
      Ciudad: "",

      from: {
        idRenovacion: "",
      },
      Estado: [],
      motivo: [],
      masisvo: [],
      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      puesto: [],
      dniUsuario: "",
      idEmpresa: "",
      cenCodigoCentro: "",
      cenCodigoSubCentro: "",
      cenCodigoSubSubCemtro: "",
      codRenMotivo: "",
      fechaIni: "1900-01-01T00:00:00.000Z",
      fechaFin: "1900-01-01T00:00:00.000Z",
      idPuesto: "0",
      sueldo: 0,
      sueldoFinal: 0,
      isdisabled: false,
      isdisabled2: false,

      CentroDeCostoMasivo: [],
      SubCentroDeCostoMasivo: [],
      idEmpresaMasivo: [],
      SubSubCentroDeCostoMasivo: [],
      cenCodigoCentroMasivo: "",
      cenCodigoSubCentroMasivo: "",
      cenCodigoSubSubCemtroMasivo: "",
      idPuestoMasivo: "",
      sueldoMasivo: "",
      fechaIniMasivo: "",
      fechaFinMasivo: "",
      colorRenovacion: "",
      fechaContraRestar: "",
      pdf: null,
      pdfMasivos: null,

      idTrabajador: "",
      pdfVariable: true,

      documentos: [],
      totalSSCC: [],
      primeraTabla: true,
      segundaTabla: false,
      terceraTabla: false,
      idTrabajadorUnico: "",

      fileInputKey: 0,
      pag: 1,
      NUM_RESULTS: 50,
      NUM_RESULTS1: 50,
      retroceder: "<<",
      avanzar: ">>",
      noAvanzar: false,
      noRetroceder: false,

      showModal: false,
      off: true,
      usuarioIndividual: [],
      Empresas: [],
      Periodo: [],
      idEmpresaParametro: "",
      periodoParams: "",
      estadoParams: "",

      busqueda: "",
      busquedaValidacion: false,
      NroDocumento: "",
      nomTrabajador: "",
      perAno: "0",
      perMes: "0",
      
      idRenovacionMasivo: [],
      ultimoEstadoMarcado: "", // 1 para marcar, 0 para desmarcar
      cambioboton :false,

      meses: [
        { value: "01", label: "Enero" },
        { value: "02", label: "Febrero" },
        { value: "03", label: "Marzo" },
        { value: "04", label: "Abril" },
        { value: "05", label: "Mayo" },
        { value: "06", label: "Junio" },
        { value: "07", label: "Julio" },
        { value: "08", label: "Agosto" },
        { value: "09", label: "Septiembre" },
        { value: "10", label: "Octubre" },
        { value: "11", label: "Noviembre" },
        { value: "12", label: "Diciembre" },
      ],
    };
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");

    this.axios.get("ParametroData/Parametro/7644").then((r) => {
      this.motivo = r.data;
    });

    this.axios.get("PuestoData/ListadoPuesto").then((r) => {
      this.puesto = r.data; //ss
    });

    this.axios.get("Empresa/ListaEmpresa").then((r) => {
      this.Empresas = r.data;
    });

    this.axios.get("Renovacion/ListadoPeriodo").then((r) => {
      this.Periodo = r.data;
    });

    // this.axios.get("Renovacion/ListadoEstadoRenovacion").then((r) => {
    //   this.Estado = r.data;
    // });

    this.axios.get("ParametroData/Parametro/7630").then((r) => {
      this.Estado = r.data;
    });
    // console.log(this.letra.length)
  },

  async created() {
    await this.GestionRenovacion();
    this.getAttributes();
    this.cambiarEstadoNavbar();
    this.BuscarAccionRenMasivo();
    // this.AccionRenMasivo();
    // this.convertBase64ToImage();
  },

  computed: {
    rows() {
      return this.ItemsGestion.length;
    },
    paginationSource() {
      // Cuando se filtra (segundaTabla), paginamos sobre esos resultados.
      return this.segundaTabla ? this.documentos : this.ItemsGestion;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.itemsFiltrados.length / 50));
    },
    años() {
      const inicio = 2022; // año desde donde quieres empezar
      const actual = new Date().getFullYear();

      return Array.from(
        { length: actual - inicio + 1 },
        (_, i) => {
          const year = inicio + i;
          return {
            value: year.toString(),
            label: year.toString()
          }
        }
      );
    },

    fechaDeahora() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${day}-${month}-${year}`;
    },

    ...mapGetters("users", ["DniEmpre"]),
    ...mapGetters("renovaciones", ["ItemsGestion"]),

    itemsFiltrados() {
      return this.ItemsGestion.filter((item) => {
        const dni = this.Dni.toLowerCase();
        const apellidos = this.Apellidos.toLowerCase();
        const ciudad = this.Ciudad.toLowerCase();
        const canal = this.SubSubCentro.toLowerCase();
        const cliente = this.Cliente.toLowerCase();
        const periodo = (this.perAno !== "0" && this.perMes !== "0") ? `${this.perAno}${this.perMes}` : "";

        return (
          (!dni || item.nroDocumento?.toLowerCase().includes(dni)) &&
          (!apellidos || item.nomTrabajador?.toLowerCase().includes(apellidos)) &&
          (!ciudad || item.departamento?.toLowerCase().includes(ciudad)) &&
          (!canal || item.subCentroCostos?.toLowerCase().includes(canal)) &&
          (!cliente || item.subSubCentroCostos?.toLowerCase().includes(cliente)) &&
          (!periodo || (item.periodo && item.periodo.toString().includes(periodo)))
        );
      });
    },
    itemsPaginados() {
      const inicio = this.NUM_RESULTS - 50;
      return this.itemsFiltrados.slice(inicio, this.NUM_RESULTS);
    },
    seleccionadosMasivo() {
      // Filtra los items de la búsqueda actual que están marcados
      return this.itemsFiltrados.filter(item => item.accionRen);
    },
   
  },

  watch: {
    Dni() { this.resetPagina(); },
    Apellidos() { this.resetPagina(); },
    Ciudad() { this.resetPagina(); },
    SubSubCentro() { this.resetPagina(); },
    Cliente() { this.resetPagina(); },
    perMes() { this.GestionRenovacion(); },
  },

  methods: {
    ...mapActions("users", ["getAttributes"]),
    ...mapActions("renovaciones", {
      GestionRenovacionStore: "GestionRenovacion"
    }),

    MarcarTodos() {
      // 1. Verificamos si todos los de la búsqueda actual ya están marcados
      const todosMarcados = this.itemsFiltrados.every(item => item.accionRen == true);

      // 2. Definimos acción: si todos están marcados -> desmarcar (0), sino -> marcar (1)
      const nuevaAccion = todosMarcados ? "0" : "1";

      // 3. Obtenemos los IDs de los registros filtrados
      const ids = this.itemsFiltrados.map(item => item.idRenovacion).join(',');

      if (!ids) return;

      Swal.fire({
        title: 'Procesando',
        text: 'Actualizando selección masiva...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const data = {
        renAccion: nuevaAccion,
        CadenaRenovacion: ids
      };

      this.axios.put("Renovacion/ModificarAccionxRenMasivo", data)
        .then(res => {
          if (res.data) {
            // Actualizamos localmente para reflejar el cambio en los checkboxes
            this.itemsFiltrados.forEach(item => {
              item.accionRen = (nuevaAccion === "1");
            });
            Swal.close();
          }
        })
        .catch(err => {
          console.error(err);
          Swal.fire('Error', 'No se pudo actualizar la selección.', 'error');
        });
    },

    GestionRenovacion() {
      return this.GestionRenovacionStore({
        perAno: this.perAno,
        perMes: this.perMes
      });
    },

    // BuscarAccionRenMasivo(){
    //     let ArrayMasivo = [];
    //             this.ItemsGestion.forEach(item => {
    //               // console.log('checkeId', item.idRenovacion);
    //                 ArrayMasivo.push(item.idRenovacion);
    //             });

    //           try {
    //           this.axios.get(`Renovacion/ValidarEstadosRenovacion?cadena=${ArrayMasivo.join(',')}`).then((response) => {
    //           const estado = response.data;
    //           this.ultimoEstadoMarcado = response.data;
    //           console.log('Estado de las renovaciones:', estado);
    //         });
    //         } catch (error) {
    //           console.error("Error en la petición", error);
    //         }
    // },

    BuscarAccionRenMasivo() {
    let ArrayMasivo = [];
    this.ItemsGestion.forEach(item => {
        ArrayMasivo.push(item.idRenovacion);
    });

    const cadenaIds = ArrayMasivo.join(',');

    // IMPORTANTE: El nombre debe ser 'CadenaRenovacion' para que C# lo mapee bien
    this.axios.post(`Renovacion/ValidarEstadosRenovacion`, { CadenaRenovacion: cadenaIds })
        .then((response) => {
            this.ultimoEstadoMarcado = response.data;
            console.log('Estado de las renovaciones:', response.data);
        })
        .catch((error) => {
            console.error("Error en la petición", error);
        });
},

    async MarcarDesmarcar() {
      this.BuscarAccionRenMasivo()
      let valorAMandar = this.ultimoEstadoMarcado;
      let ArrayMasivo = [];
      this.ItemsGestion.forEach(item => {
        console.log('checkeId', item.idRenovacion);
          ArrayMasivo.push(item.idRenovacion);
      });
    // 2. Validamos que el array no esté vacío
      if (ArrayMasivo.length === 0) return;
        console.log('ss',valorAMandar)
       if (valorAMandar== 1) {
            valorAMandar = 0; // Desmarcar
        } else if (valorAMandar == 3) {
            valorAMandar = 1; // Normalizar a Marcado
        } else {
            valorAMandar = 1; // Estaba en 0, marcar todo
        }

        console.log('Valor a mandar:', valorAMandar);

      // 3. Preparamos el objeto con la nomenclatura que espera tu C#
      const oAccxRen = {
        renAccion: `${valorAMandar}`, // 1 para marcar, 0 para desmarcar
        CadenaRenovacion: ArrayMasivo.join(',') // "1,2,3,4,5"
      };

       
      try {
      // 4. Llamada a la nueva API (usando PUT)
      const response = await this.axios.put('Renovacion/ModificarAccionxRenMasivo', oAccxRen);

          if (response.data == true) {
            console.log(`Acción masiva (${valorAMandar}) completada con éxito`);
            // 5. Refrescar la lista para ver los cambios
            this.GestionRenovacion(); 
          } else {
            console.error("El servidor respondió con un error");
          }
        } catch (error) {
          console.error("Error al conectar con la API:", error);
        }
      
      },

    AccionRenMasivo(){
      this.idRenovacionMasivo = [];
      this.ItemsGestion.forEach(item => {
          if(item.accionRen == true){
            this.idRenovacionMasivo.push(item.idRenovacion);   
            console.log('checkeId', this.idRenovacionMasivo);         
          }
        });

        
        const oRenovacion = {
        idUsuario: this.idUsuario, // O la variable que uses para el usuario
        CadenaRenovacion: this.idRenovacionMasivo.join(',') 
          };  
          
          this.axios.put("Renovacion/ModificarRenovacionMasivo", oRenovacion).then((response) => {
            console.log(response);
            if (response.status == 200) {
              Swal.fire({
                icon: "success",
                title: "¡Éxito!",
                text: "Renovaciones modificadas correctamente.",
              });
              this.GestionRenovacion(); // Refrescar la lista después de la modificación
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "No se pudieron modificar las renovaciones.",
              });
            }
          }).catch((error) => {
            console.error("Error al modificar renovaciones:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Ocurrió un error al modificar las renovaciones.",
            });
          });
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    BuscarCampaña(entrada) {
      this.documentos = [];
      this.primeraTabla = false;
      this.axios
        .get(`Renovacion/BusquedaCamapana`, {
          params: {
            idTrabajador: this.idTrabajador,
            perAno: this.perAno,
            perMes: this.perMes,
            renEstado: entrada,
          },
        })
        .then((r) => {
          console.log(r.data);
          this.segundaTabla = true;

          this.documentos = r.data;
          this.irInicio();
        });
    },

    fetchItems() {
      console.log(this.Dni.length);

      if (this.Dni.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        // this.terceraTabla = false;
        this.GestionRenovacion();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxDni`, {
            params: {
              idTrabajador: this.idTrabajador,
              NroDocumento: this.Dni,
              perAno: this.perAno,
              perMes: this.perMes,
              codEstado: 0,
              opcion :2
            },

          })
          .then((response) => {
            console.log(response);

            if (response.status == 200) {
              this.primeraTabla = false;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              this.irInicio();
            }
            // this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

   fetchApellido() {
      console.log(this.Apellidos.length);

      if (this.Apellidos.length == 0) {
        this.GestionRenovacion();
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.documentos = [];
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxApellido`, {
            params: {
              Apellido: this.Apellidos,
              idTrabajador: localStorage.getItem("idTrabajdor"),
              perAno: this.perAno,
              perMes: this.perMes,
              codEstado: '002',
              opcion : 2
            },
          }
          )
          .then((response) => {
            console.log(response.status);

            if (this.Apellidos.length == 0) {
          this.primeraTabla = true;
          this.segundaTabla = false;
          this.documentos = [];
          return; // Detenemos la ejecución aquí
        }

        if (response.status) {
          this.primeraTabla = false;
          this.segundaTabla = true;
          this.documentos = response.data;
          console.log(response.data);
          this.irInicio();
        }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    fetchSubSubCentro() {
      this.documentos = [];
      if (this.SubSubCentro.length == 0) {
        this.primeraTabla = true;
        this.documentos = [];
        this.segundaTabla = false;
        // this.terceraTabla = false;
        this.GestionRenovacion();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxSubSubCc`, {
            params: {
              idTrabajador: this.idTrabajador,
              cuenta: this.SubSubCentro,
              perAno: this.perAno,
              perMes: this.perMes,
              codEstado: 0,
              opcion:2
            },
          }
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              // this.segundaTabla = false;
              // this.terceraTabla = true;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
              this.irInicio();
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchCiudad() {
      this.documentos = [];
      if (this.Ciudad.length == 0) {
        this.primeraTabla = true;
        this.documentos = [];
        this.segundaTabla = false;
        // this.terceraTabla = false;
        this.GestionRenovacion();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxDepa?departamento=${this.Ciudad}&idTrabajador=${this.idTrabajador}&codEstado=002`
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              // this.segundaTabla = false;
              // this.terceraTabla = true;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
              this.irInicio();
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    Filtro() {
      console.log(this.busqueda);
      if (this.busqueda.length > 0) {
        this.axios
          .get(
            `Renovacion/BuscarRenovacion?idTrabajador=${this.idTrabajador
            }&idEmpresa=${this.idEmpresaParametro
            }&periodo=${this.periodoParams.replace("-", "")}&renEstado=${this.estadoParams
            }&palabraClave=${this.busqueda.toUpperCase()}`
          )
          .then((r) => {
            console.log(r.data);
            this.documentos = r.data;
            this.segundaTabla = true;
            this.irInicio();
          });
      } else {
        this.BusquedaFiltros();
      }
    },

    BusquedaFiltros() {
      console.log(
        this.idTrabajador,
        this.idEmpresaParametro,
        this.estadoParams
      );
      this.axios
        .get(`Renovacion/BusquedaGeneralRen`, {
          params: {
            idTrabajador: this.idTrabajador,
            perAno: this.perAno,
            perMes: this.perMes,
            renEstado: "002",
            idEmpresa: this.idEmpresaParametro,
          },
        })
        .then((r) => {
          console.log(r.data);
          this.documentos = r.data;
          this.primeraTabla = false;
          this.segundaTabla = true;
          this.busquedaValidacion = true;
          this.irInicio();
        });
    },

    CambiarEstado() {
      this.axios.put(`Renovacion/CambioEstadoGestion`).then((r) => {
        console.log(r.data);
        this.GestionRenovacion();
      });
    },

    openModal(url) {
      console.log(url);

      this.axios.get(`Renovacion/Renovacionxid/${url}`).then((r) => {
        console.log(r.data);
        this.showModal = true;

        this.usuarioIndividual = r.data;
      });
    },

    closeModal() {
      this.showModal = false;
      this.usuarioIndividual = [];
    },

    cerrar() {
      this.showModal = false;
    },

    MarcarSSCC() {
      this.documentos.map((r) => {
        this.totalSSCC.push(r.idRenovacion);
      });

      console.log(this.totalSSCC);

      const from = {
        idRenovaciones: `${this.totalSSCC}`,
      };

      this.axios.put(`Renovacion/CambioEstadoGestion`, from).then((r) => {
        console.log(r.data);
        this.GestionRenovacion();
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.terceraTabla = false;
      });
    },

    cambiarEstadoPdf(id) {
      this.axios.put(`Renovacion/EstadoPdf?idRenovacion=${id}`).then((r) => {
        console.log(r.data);
        Swal.fire(`Cambio de estado realizado`, "", "success");
        this.GestionRenovacion();
      });
    },

    mandarPdfServicios(id, trabajador, dni, nomTrabajador) {
      this.idRenovacion = id;
      this.idTrabajador = trabajador;
      this.NroDocumento = dni;
      this.nomTrabajador = nomTrabajador;
    },

    handleFileUpload(event) {
      let file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        console.log(file);

        let formData = new FormData();
        formData.append("Archivo", file);
        formData.append("idRenovacion", this.idRenovacion);
        formData.append("NroDocumento", this.NroDocumento);
        formData.append("nomTrabajador", this.nomTrabajador.replace(/ /g, "_"));
        const today = new Date();

        const day = String(today.getDate()).padStart(2, "0"); // Día con cero delante si es necesario
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Mes (¡+1 porque empieza en 0!)
        const year = today.getFullYear();

        const fechaHoy = `${day}-${month}-${year}`; // Resultado: "15-09-2025"

        formData.append("fechaHoy", fechaHoy);

        this.fileInputKey += 1;

        this.axios
          .put("Renovacion/AdjuntoRen", formData)
          .then((response) => {
            console.log(response.data ,'llegue 1');
            if (response.data == true) {
              for (let index of this.ItemsGestion) {
                if (
                  index.idPuesto === index.idPuestoNuevo &&
                  this.idTrabajador === index.idTrabajador &&
                  index.renSueldoActual == index.renSueldo
                ) {
                  console.log(index);
                  // renCodSscc
                  console.log("SE APLICO INSERTAR IMAGEPDF");
                  console.log(this.NroDocumento);
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenPdf?idRenovacion=${this.idRenovacion
                      }&nroDocumento=${this.NroDocumento
                      }&NombreTrabajador=${this.nomTrabajador.replace(
                        / /g,
                        "_"
                      )}&fecha=${fechaHoy}`
                    )
                    .then((r) => {
                      console.log(r.data, 'llegue 2');
                      if (r.data == true) {
                        this.axios
                          .get(
                            `Renovacion/InsertSelloPdf?idRenovacion=${this.idRenovacion
                            }&nroDocumento=${this.NroDocumento
                            }&NombreTrabajador=${this.nomTrabajador.replace(
                              / /g,
                              "_"
                            )}&fecha=${fechaHoy}`
                          )
                          .then((r) => {
                            console.log(r.data, 'llegue 3');
                            if (r.data) {
                              this.axios
                                .put(
                                  `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                                )
                                .then((r) => {
                                  console.log(r.data);
                                  if (r.data == true) {
                                    Swal.fire("Guardado", "", "success");
                                    // this.fetchApellido();
                                     this.GestionRenovacion();
                                    // this.segundaTabla = false;
                                    this.primeraTabla = true;
                                    this.idTrabajador = "";
                                    this.idRenovacion = "";
                                    // this.Dni = "";
                                    // this.Apellidos = "";
                                    // this.SubSubCentro = "";
                                    // this.Ciudad = "";
                                  }
                                });
                            }
                          });
                      }
                    });
                }

                if (
                  this.idTrabajador === index.idTrabajador &&
                  index.renSueldoActual != index.renSueldo &&
                  index.idPuesto === index.idPuestoNuevo
                ) {
                  console.log("SE APLICO INSERTAR ADEDA");
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenAdenda?idRenovacion=${this.idRenovacion
                      }&nroDocumento=${this.NroDocumento
                      }&NombreTrabajador=${this.nomTrabajador.replace(
                        / /g,
                        "_"
                      )}&fecha=${fechaHoy}`
                    )
                    .then((r) => {
                      if (r.data == true) {
                        this.axios
                          .get(
                            `Renovacion/InsertSelloAdenda?idRenovacion=${index.idRenovacion
                            }&nroDocumento=${this.NroDocumento
                            }&NombreTrabajador=${this.nomTrabajador.replace(
                              / /g,
                              "_"
                            )}&fecha=${fechaHoy}`
                          )
                          .then((r) => {
                            if (r.data) {
                              this.axios
                                .put(
                                  `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                                )
                                .then((r) => {
                                  console.log(r.data);
                                  if (r.data == true) {
                                    Swal.fire("Guardado", "", "success");
                                     this.GestionRenovacion();
                                    // this.fetchApellido();
                                    // this.segundaTabla = false;
                                    this.primeraTabla = true;
                                    this.idTrabajador = "";
                                    this.idRenovacion = "";
                                    // this.Dni = "";
                                    // this.Apellidos = "";
                                    // this.SubSubCentro = "";
                                    // this.Ciudad = "";
                                  }
                                });
                            }
                          });
                      }
                    });
                }

                if (
                  index.idPuesto != index.idPuestoNuevo &&
                  index.renSueldoActual == index.renSueldo &&
                  this.idTrabajador == index.idTrabajador
                ) {
                  console.log("SE APLICA INSERTADR ADENDA 2");
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenAdenda?idRenovacion=${this.idRenovacion
                      }&nroDocumento=${this.NroDocumento
                      }&NombreTrabajador=${this.nomTrabajador.replace(
                        / /g,
                        "_"
                      )}&fecha=${fechaHoy}`
                    )
                    .then((r) => {
                      if (r.data == true) {
                        this.axios
                          .get(
                            `Renovacion/InsertSelloAdenda?idRenovacion=${this.idRenovacion
                            }&nroDocumento=${this.NroDocumento
                            }&NombreTrabajador=${this.nomTrabajador.replace(
                              / /g,
                              "_"
                            )}&fecha=${fechaHoy}`
                          )
                          .then((r) => {
                            if (r.data) {
                              this.axios
                                .put(
                                  `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                                )
                                .then((r) => {
                                  console.log(r.data);
                                  if (r.data == true) {
                                    Swal.fire("Guardado", "", "success");                                    
                                     this.GestionRenovacion();
                                    this.idTrabajador = "";
                                    this.idRenovacion = "";
                                    // this.segundaTabla = false;
                                    this.primeraTabla = true;
                                    // this.Dni = "";
                                    // this.Apellidos = "";
                                    // this.SubSubCentro = "";
                                    // this.Ciudad = "";
                                  }
                                });
                            }
                          });
                      }
                    });
                }

                if (
                  index.idPuesto != index.idPuestoNuevo &&
                  index.renSueldoActual !== index.renSueldo &&
                  this.idTrabajador == index.idTrabajador
                ) {
                  console.log("SE APLICA INSERTADR ADENDA 2");
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenAdenda?idRenovacion=${this.idRenovacion
                      }&nroDocumento=${this.NroDocumento
                      }&NombreTrabajador=${this.nomTrabajador.replace(
                        / /g,
                        "_"
                      )}&fecha=${fechaHoy}`
                    )
                    .then((r) => {
                      if (r.data == true) {
                        this.axios
                          .get(
                            `Renovacion/InsertSelloAdenda?idRenovacion=${this.idRenovacion
                            }&nroDocumento=${this.NroDocumento
                            }&NombreTrabajador=${this.nomTrabajador.replace(
                              / /g,
                              "_"
                            )}&fecha=${fechaHoy}`
                          )
                          .then((r) => {
                            if (r.data) {
                              this.axios
                                .put(
                                  `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                                )
                                .then((r) => {
                                  console.log(r.data);
                                  if (r.data == true) {
                                    Swal.fire("Guardado", "", "success");
                                    // this.fetchApellido();
                                     this.GestionRenovacion();
                                    this.idTrabajador = "";
                                    this.idRenovacion = "";
                                    // this.segundaTabla = false;
                                    // this.primeraTabla = true;
                                    // this.Dni = "";
                                    // this.Apellidos = "";
                                    // this.SubSubCentro = "";
                                    // this.Ciudad = "";
                                  }
                                });
                            }
                          });
                      }
                    });
                }
              }
            }

            // Realizar acciones adicionales según sea necesario
          })
          .catch((error) => {
            console.error(error);
            // Manejar el error de alguna manera
          });
      } else {
        // Archivo inválido, muestra un mensaje de error o realiza acciones adicionales
        console.error("Seleccione un archivo PDF válido");
      }
      // Aquí puedes realizar las acciones necesarias con el archivo subido, como enviarlo al servidor o procesarlo.
    },

    Firma(items) {
      // this.firmasDigital = true
      this.idTrabajador = items.idTrabajador;

      this.$router.push("/firmas/" + items.idTrabajador);
    },

    cambiarEstadoRen(items) {
      Swal.fire({
        title: "¿Confirmar cambio de estado?",
        text: "¿Desea cambiar el estado a 'No Renovado' para este trabajador?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log(items.idTrabajador);
          this.axios
            .put(`Renovacion/EstadoNoRenovado?idRenovacion=${items.idRenovacion}`)
            .then((r) => {
              if (r.data) {
                Swal.fire(`Cambio de estado realizado`, "", "success");
              }
              this.GestionRenovacion();
            });
        }
      });
    },

    Registro(items) {
      this.idRenovacion = items.idRenovacion;

      console.log(items);
      const form = {
        idRenovacion: items.idRenovacion,
        idrenResponsable: items.idrenResponsable,
        renCodCC: items.renCodCC,  // no es necesario
        renCodScc: items.renCodScc, // no es necesario
        renCodSscc: this.cenCodigoSubSubCemtro, // no es necesario
        idPuestoNuevo: this.idPuesto, // no es necesario
        renSueldo: this.sueldoFinal,  // no es necesario
        codRenMotivo: this.codRenMotivo === "" ? "000" : this.codRenMotivo,
        fechaIniContrato: items.fechaIniContrato, // no es necesario
        fechaFinContrato: items.fechaFinContrato, // no es necesario
        idUsuario: localStorage.getItem("userId"),
        EstadoPdf: items.estadoPdf,
        AccionRen: items.accionRen,
        EstadoAdjunto: items.estadoAdjunto,
        renCodEstado: "003",
      };

      console.log(form);

      this.axios.put("Renovacion/ModificarRenovacion", form).then((r) => {
        if (r.data == true) {
          Swal.fire(`Registro Realizado`, "", "success");
          this.Dni = "";
          this.Apellidos = "";
          this.SubSubCentro = "";
          this.Ciudad = "";
          this.primeraTabla = true;
          this.GestionRenovacion();
          this.idRenovacion = "";
        }
      });
    },

    Rechazo(idRenovacion, item) {
      console.log(idRenovacion);

      Swal.fire({
        title: '¿Confirmar rechazo de renovación?',
        text: "El contrato no será renovado.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Si",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .put(`Renovacion/ModificarEstadoxRen?idRenovacion=${idRenovacion}`)
            .then((r) => {
              console.log(r.data);
              if (r.data) {
                this.GestionRenovacion();
                this.axios
                  .post(
                    `Renovacion/CorreoRechazo?correoUsuario=procesos.automaticos@gruposolimano.com.pe&Nombre=${item.nomTrabajador}&Motivo=${this.texto}`
                  )
                  .then((r) => {
                    console.log(r.data);
                  });
              }
            });
          Swal.fire("Rechazado!", "", "success");
        }
      });
    },

    DescargarPdf(items) {
      for (let index of this.ItemsGestion) {
        if (
          items.idPuesto === index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual == index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("hola1");
          console.log(index);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarPdf?idrenovacion=${items.idRenovacion}&nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&SubSubCentro=${items.subSubCentroCostos}&nroDni=${items.numeroDoc}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r;
              console.log(r);
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename);
              }
            });
        }

        if (
          items.idPuesto === index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual != index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("se cambio el sueldo");
          console.log(items);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarAdenda?idRenovacion=${items.idRenovacion}&nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}&nroDni=${items.numeroDoc}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r;
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename);
              }
            });
        }

        if (
          items.idPuesto != index.idPuestoNuevo &&
          items.idTrabajador == index.idTrabajador &&
          index.renSueldoActual == index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("se cambio el puesto");
          console.log(items.nomLargoEmp);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarAdenda?idRenovacion=${items.idRenovacion}&nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}&nroDni=${items.numeroDoc}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r;
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename);
              }
            });
        }

        if (
          items.idPuesto !== index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual != index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("see cambiaron los dos");
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarAdenda?idRenovacion=${items.idRenovacion}&nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}&nroDni=${items.numeroDoc}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r;
              console.log("hola mundo");
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename);
              }
            });
        }
      }
    },

    GenerarPdf(filename) {
      var fileURL = window.URL.createObjectURL(new Blob([this.pdf.data]));
      var fileLink = document.createElement("a");

      console.log(filename);
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${filename}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
      window.URL.revokeObjectURL(fileURL);
    },

    CrearPdfMasivo() {
      this.axios
        .get(`RenMasivo/GenerarPdfMasivo/${this.checkeId}`, {
          responseType: "blob",
        })
        .then((r) => {
          console.log(r.data);
          this.pdfMasivos = r.data;
          if (r.status === 200) {
            this.GenerarPdfMasivo();
          }
        });
    },

    GenerarPdfMasivo() {
      var fileURL = window.URL.createObjectURL(new Blob([this.pdfMasivos]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "usuario.pdf");
      document.body.appendChild(fileLink);
      fileLink.click();
    },

    Indi() {
      this.individual = true;
      this.masivo = false;
      this.GestionRenovacion();
      this.isdisabled2 = false;
    },

    Masi() {
      (this.individual = false), (this.masivo = true);
      this.GestionRenovacion();
      this.checkeId = [];
    },

    Motivos(event) {
      this.codRenMotivo = event.target.value;
    },

    Motivo(event) {
      this.texto = event.target.value;
      console.log(event.target.value);
    },

    SubSubCentroCostos(event) {
      this.cenCodigoSubCentro = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${this.cenCodigoCentro}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroCosto = r.data;
          console.log(r.data);
        });
    },
    // annes

    SubSubCentroCostosManda(event) {
      this.cenCodigoSubSubCemtro = event.target.value;
      console.log(event.target.value);
    },

    Puesto(event) {
      this.idPuesto = event.target.value;
    },

    mostrar(event) {
      this.sueldo = event.target.value;
      console.log(event.target.value);
    },

    FechaIni(event) {
      this.fechaIni = event.target.value;
      console.log(event.target.value);
    },

    FechaFin(event) {
      this.fechaFin = event.target.value;
    },

    actualizarEstado(items) {
      this.from.idRenovacion = items.idRenovacion;

      for (let index of this.ItemsGestion) {
        if (index.idRenovacion == items.idRenovacion) {
          this.axios
            .get(
              `SubSubCentro/SScxTrabajador?idEmpresa=${index.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${index.renCodCC}&codSubCentro=${index.renCodScc}`
            )
            .then((r) => {
              this.SubSubCentroCosto = r.data;
              console.log(r.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      if (items.accionRen == true) {
        this.isdisabled2 = true;

      }


      console.log('prueba' ,items.accionRen);
        this.axios.put("Renovacion/ModificarAccionxRen", this.from).then((r) => {
                console.log(r.data);


               this.BuscarAccionRenMasivo()

               if (this.conteoMarcados > 1) {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
               }
         }); 
      

      console.log(items);
    },

    CentroCostoMasivo(event) {
      this.idEmpresaMasivo = event.target.value;
      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniUsuario}`
        )
        .then((r) => {
          this.CentroDeCostoMasivo = r.data;
          console.log(r.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    SubCentroCostoMasivo(event) {
      this.cenCodigoCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${event.target.value}&dniUser=${this.dniUsuario}&idEmpresa=${this.idEmpresaMasivo}`
        )
        .then((r) => {
          this.SubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroDeCostosMasivo(event) {
      this.cenCodigoSubCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresaMasivo}&dniUser=${this.dniUsuario}&codCentro=${this.cenCodigoCentroMasivo}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroCostosMandaMasivo(event) {
      this.cenCodigoSubSubCemtroMasivo = event.target.value;
      console.log(event.target.value);
    },

    PuestoMasivo(event) {
      this.idPuestoMasivo = event.target.value;
      console.log(event.target.value);
    },

    CargaMasiva() {
      let contadorFinalDePdf = 0;
      for (let index of this.checkeId) {
        console.log(index);
        this.axios
          .get(`Renovacion/GuardarPdfMasivo?idRenovacion=${index}`)
          .then((r) => {
            console.log(r.data);
            contadorFinalDePdf += 1;
            if (r.data == true && contadorFinalDePdf == this.checkeId.length) {
              Swal.fire("Guardado", "", "success");
              console.log("recien aplico la alerta", contadorFinalDePdf);
            }
          });
      }
    },

    retroceso() {
      if (this.NUM_RESULTS === 50) {
        this.noRetroceder = true;
      } else {
        this.NUM_RESULTS -= 50;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
      }
    },

    resetPagina() {
      this.irInicio();
    },

    aumentar() {
      this.NUM_RESULTS += 50;
      this.pag += 1;

      if (this.NUM_RESULTS > 50) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }

      if (this.NUM_RESULTS >= this.itemsFiltrados.length) {
        this.noAvanzar = true;
      } else {
        this.noAvanzar = false;
      }
    },

    irInicio() {
      this.NUM_RESULTS = 50;
      this.pag = 1;
      this.noRetroceder = true;
      this.noAvanzar = this.itemsFiltrados.length <= 50;
    },

    irFinal() {
      const totalPages = this.totalPages;
      this.pag = totalPages;
      this.NUM_RESULTS = totalPages * 50;
      this.noAvanzar = true;
      this.noRetroceder = false;
    },
  },
};
</script>

<style scoped>

.bg-check{
  background: #f0f0f0;
}

.label-column {
  width: 140px;
  /* Puedes ajustar este valor según tus necesidades */
  display: inline-block;
  text-align: left;
  /* Para alinear el texto del <strong> a la derecha */
  font-size: 0.84rem;
  margin-right: 0px;
  /* Agregar un margen entre <strong> y <label> */
}

.disabled-row {
  background: #f7c8cc;
  /* opacity: 0.5; /* Cambia esto según la opacidad deseada */
  /* pointer-events: none; /* Evita la interacción con los elementos en la fila */
}

.toggle-transition {
  transition: all 0.3s ease;
  /* Cambia la duración y el tipo de transición según tus preferencias */
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  /* Fondo más transparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: auto;
  /* Permite eventos de ratón en el modal */
}

.modal-content {
  width: 64%;
  height: auto;
  background-color: #fbfbfb;
  border: 3px rgb(60, 60, 60) solid;
  padding: 0.5%;
}

select {
  margin-top: 0px;
  padding: 0px;
  width: auto;
  display: inline-block;

  text-align: center;
}

label {
  padding: 0px;
}

input[type="date"] {
  padding: 0px;
  height: auto;
}

input[type="text"] {
  min-width: 150px;
  padding: 0px;
}

.custom-file-upload {
  display: inline-block;
  padding: 10px 15px;
  background: #ffffff;
  color: rgb(255, 255, 255);
  cursor: pointer;
  border-radius: 4px;
}

.custom-file-upload:hover {
  background: #b6b6b6;
}

#file-upload {
  display: none;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565c0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.2rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.3rem 0.55rem;
}

.label-resaltado {
  font-weight: 700;
  font-size: 0.75rem;
}
</style>
